import { useCallback } from "react";

export const useWhatsAppApi = () => {
  const sendMessage = useCallback((message: string) => {
    const phoneNumber = process.env.REACT_APP_WHATSAPP_NUMBER;

    if (!phoneNumber) {
      console.error("WhatsApp number is not defined in environment variables.");
      return;
    }

    const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
      message
    )}`;

    window.open(url, "_blank");
  }, []);

  return sendMessage;
};
